export const StatTooltip = ({ description, title }: { title?: string; description?: string }) => {
  return (
    <div className="flex flex-col gap-1">
      {title && <h2 className="font-medium text-sm text-white">{title}</h2>}
      {description && <p className="text-xs">{description}</p>}
    </div>
  )
}
